import React, { lazy, Suspense, Fragment, useEffect } from 'react';
import {
	BrowserRouter as Router,
	Route,
	Switch,
	Redirect,
} from 'react-router-dom';
import { LoadingGif } from './components/elements/Loading';
import { Provider } from 'react-redux';
import store from './store';
import setAuthToken from './utils/setAuthToken';
import { loadUser, logout } from './actions/register';
import PrivateRoute from './utils/routing/PrivateRoute';
import './components/styles/main.css';
import { getProjects } from './actions/project';

const Alerts = lazy(() => import('./components/elements/Alerts'));
const Login = lazy(() => import('./components/AuthPages/Login'));
const Register = lazy(() => import('./components/AuthPages/Register'));
const Confirm = lazy(() => import('./components/AuthPages/Confirm'));

const Landing = lazy(() => import('./components/Landing'));

const Home = lazy(() => import('./components/Pages/Home'));
const TrialSongHome = lazy(() => import('./components/Pages/TrialSongsHome'));
const TrialSong = lazy(() => import('./components/Pages/TrialSong'));
const Project = lazy(() => import('./components/Pages/Project'));
const Participants = lazy(() => import('./components/Pages/Participants'));
const Telemetry = lazy(() => import('./components/Pages/Telemetry'));
const Renders = lazy(() => import('./components/Pages/Renders'));
const Studio = lazy(() => import('./components/Pages/Studio'));
const StudioNew = lazy(() => import('./components/Pages/StudioNew'));
const PaxStudio = lazy(() => import('./components/Pages/PaxStudio'));

if (localStorage.token) {
	setAuthToken(localStorage.token);
}

const App = () => {
	useEffect(() => {
		store.dispatch(loadUser());
		const handleInvalidToken = e => {
			if (e.key === 'token' && e.oldValue && !e.newValue) {
				store.dispatch(logout());
			}
		};
		window.addEventListener('storage', handleInvalidToken);
		return function cleanup() {
			window.removeEventListener('storage', handleInvalidToken);
		};
	}, []);
	return (
		<Provider store={store}>
			<Router>
				<Suspense fallback={LoadingGif}>
					<Fragment>
						<section>
							<Alerts />
							<Switch>
								<Route exact path='/login' component={Login} />
								<Route exact path='/register' component={Register} />
								<Route exact path='/confirm/:token' component={Confirm} />

								<Route exact path='/' component={Landing} />

								<PrivateRoute exact path='/home' component={Home} />
								<PrivateRoute
									exact
									path='/songhome'
									component={TrialSongHome}
								/>
								<PrivateRoute
									exact
									path='/song/:songId'
									component={TrialSong}
								/>
								<PrivateRoute
									exact
									path='/project/participants/:projectId'
									component={Participants}
								/>
								<PrivateRoute
									exact
									path='/project/telemetry/:projectId'
									component={Telemetry}
								/>
								<PrivateRoute
									exact
									path='/project/renders/:projectId'
									component={Renders}
								/>
								<PrivateRoute
									exact
									path='/project/studio/:projectId'
									component={Studio}
								/>
								<PrivateRoute
									exact
									path='/project/studio/v2/:projectId'
									component={StudioNew}
								/>
								<PrivateRoute
									exact
									path='/project/paxstudio/:projectId'
									component={PaxStudio}
								/>
								<PrivateRoute
									exact
									path='/project/:projectId'
									component={Project}
								/>
								<Redirect from='*' to='/' />
							</Switch>
						</section>
					</Fragment>
				</Suspense>
			</Router>
		</Provider>
	);
};

export default App;
